<div class="title-page d-flex justify-content-between">
    <div class="title">
        Đồng Bộ Dữ Liệu
    </div>
    <BreadcrumbComponent></BreadcrumbComponent>
</div>
<div style="background: #f7f8f9;height: 100%">
    <div class="container-fluid">
        <div class="card">
            <ul class="nav nav-tabs m-5" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_PRODUCT_KIOTVIET}"
                            id="product-tab" data-bs-toggle="tab" data-bs-target="#product" type="button" role="tab"
                            aria-controls="product" aria-selected="true" @click="changeTab('product')">Sản Phẩm
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_PARTNER_KIOTVIET}"
                            id="partner-tab" data-bs-toggle="tab" data-bs-target="#partner" type="button" role="tab"
                            aria-controls="partner" aria-selected="false" @click="changeTab('partner')">Đối tác
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_DELIVERY_KIOTVIET}"
                            id="delivery-tab" data-bs-toggle="tab" data-bs-target="#delivery" type="button" role="tab"
                            aria-controls="delivery" aria-selected="false" @click="changeTab('delivery')">Đặt Hàng
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_INVOICE_KIOTVIET}"
                            id="invoice-tab" data-bs-toggle="tab" data-bs-target="#invoice" type="button" role="tab"
                            aria-controls="invoice" aria-selected="false" @click="changeTab('invoice')">Hóa Đơn
                    </button>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="product" role="tabpanel" aria-labelledby="product-tab">
                    <TabProductComponent :tabCurrent="tabCurrent"></TabProductComponent>
                </div>
                <div class="tab-pane fade" id="partner" role="tabpanel" aria-labelledby="partner-tab">
                    <TabPartnerComponent :tabCurrent="tabCurrent"></TabPartnerComponent>
                </div>
                <div class="tab-pane fade" id="delivery" role="tabpanel" aria-labelledby="delivery-tab">
                    <TabDeliveriesComponent :tabCurrent="tabCurrent"></TabDeliveriesComponent>
                </div>
                <div class="tab-pane fade" id="invoice" role="tabpanel" aria-labelledby="invoice-tab">
                    <TabInvoiceComponent :tabCurrent="tabCurrent"></TabInvoiceComponent>
                </div>
            </div>
        </div>
    </div>
</div>